import { CALL_API } from '../../middleware/api';
/**
 * OKR 全局定义
 */
export const CHANGE_TIME_FRAME_SUCCESS = 'CHANGE_TIME_FRAME_SUCCESS';

export function changeTimeFrame(newTimeFrame) {
  return {
    type: CHANGE_TIME_FRAME_SUCCESS,
    newTimeFrame
  }
}



// WEBPACK FOOTER //
// ./src/action/okr_manage/okr.js